import type { CaseLeg } from '@/types/domain'

/** One handover point on a route. */
export interface RouteStopPoint {
  name: string
  /** From whichever leg named one: the arriving leg's destination country, and
   *  the departing leg's origin country when it did not. The two are the same
   *  place, and a domestic road leg that carries no country must not blank the
   *  flag the rail leg before it put there. */
  country?: string
}

/** The chain a route's legs make: the origin of the first, then every
 *  destination in turn.
 *
 *  Its own module rather than a second export from `RouteStrip`, which is the
 *  file that draws it: a component file that also exports a function is a file
 *  fast refresh gives up on. It is pure and it is where the one rule worth
 *  testing lives — that a handover point keeps its flag when only one of the
 *  two legs meeting there named a country. */
export function routeStops(legs: CaseLeg[]): RouteStopPoint[] {
  if (legs.length === 0) return []

  const first = legs[0]!
  const stops: RouteStopPoint[] = [{ name: first.origin, country: first.originCountry }]

  legs.forEach((leg, index) => {
    stops.push({
      name: leg.destination,
      country: leg.destinationCountry ?? legs[index + 1]?.originCountry,
    })
  })

  return stops
}
